import { useEffect, useState } from "react";
import ArticleCard from "./ArticleCard";
import Header from "./Header";
import { useToast } from "@chakra-ui/react";

function Leads() {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const login = JSON.parse(localStorage.getItem("login")) || "";
  const toast = useToast()
  const [plan, setPlan] = useState({})

  const fetchLead = async () => {
    try {
      const response = await fetch(
        `https://filmlocation.100billion.in/leads/leadsnew/${login.permanent_ID}`
      );

      const res = await response.json();

      const parsed = res.user.map((lead) => ({
        ...lead,
        store: lead.store ? JSON.parse(lead.store) : null,
      }));

      setLeads(parsed);
      setFilteredLeads(parsed);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchLead();
  }, []);


  const applyFilters = () => {
    let result = [...leads];

    if (search.trim() !== "") {
      result = result.filter(
        (lead) =>
          lead.name.toLowerCase().includes(search.toLowerCase()) ||
          lead.phone.includes(search) ||
          lead.email?.toLowerCase().includes(search.toLowerCase()) ||
          lead.store.businessDetails.businessName
            .toLowerCase()
            .includes(search.toLowerCase())
      );
    }

    const now = new Date();


    const applyLastDays = (days) =>
      result.filter((lead) => {
        const diff = (now - new Date(lead.createdAt)) / (1000 * 3600 * 24);
        return diff <= days;
      });


    switch (filterType) {
      case "today":
        result = result.filter(
          (l) => new Date(l.createdAt).toDateString() === now.toDateString()
        );
        break;

      case "yesterday":
        let y = new Date();
        y.setDate(y.getDate() - 1);
        result = result.filter(
          (l) => new Date(l.createdAt).toDateString() === y.toDateString()
        );
        break;

      case "7":
      case "14":
      case "28":
      case "60":
      case "90":
        result = applyLastDays(parseInt(filterType));
        break;

      case "custom":
        if (customFrom && customTo) {
          const from = new Date(customFrom);
          const to = new Date(customTo);

          result = result.filter((l) => {
            const d = new Date(l.createdAt);
            return d >= from && d <= to;
          });
        }
        break;

      default:
        break;
    }

    setFilteredLeads(result);
  };

  useEffect(() => {
    applyFilters();
  }, [search, filterType, customFrom, customTo, leads]);

  const updateStatusInBackend = async (id, newStatus) => {
    try {
      const response = await fetch("https://filmlocation.100billion.in/leads/update-status", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, status: newStatus }),
      });


      const res = await response.json();
      if (response.ok) {
        toast({
          description: `Status updated`,
          status: 'success',
          duration: 5000,
          position: 'top-center',
          isClosable: true,
        });
        setLeads((prev) =>
          prev.map((lead) =>
            lead.id === id ? { ...lead, status: newStatus } : lead
          )
        );
      }

    } catch (error) {
      toast({
        description: `${error.message}`,
        status: 'error',
        duration: 5000,
        position: 'top-center',
        isClosable: true,
      });
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLeads.slice(indexOfFirstItem, indexOfLastItem);

  const handleQuickFilter = (type) => {
    setFilterType(type);
    setShowDropdown(false);
  };

  const saveConnectedTime = async (leadId, type) => {
    try {
      const now = new Date().toISOString();

      await fetch("https://filmlocation.100billion.in/leads/leadsnew/update-connected-time", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: leadId, type }),
      });

      // UPDATE UI INSTANTLY
      setLeads(prev =>
        prev.map((lead) =>
          lead.id === leadId ? { ...lead, connected_time: now } : lead
        )
      );

    } catch (err) {
      console.log("Connected time error:", err);
    }
  };

  const planData = async () => {
    try {
      const response = await fetch(`https://filmlocation.100billion.in/store/plancheck/getstorelist/mystore/${login.permanent_ID}`)
      const res = await response.json();
      console.log(res);
      setPlan(res);
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    planData();
  }, [])

   const isFree = !plan || !plan.sale_price || plan.sale_price === 0;

  return (
    <>
      <Header />

      <div className="filter-bar">
        <input
          className="filter-search"
          placeholder="Search by name, phone, email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="date-dropdown">
          <button
            className="dropdown-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            Filter:{" "}
            {{
              all: "All",
              today: "Today",
              yesterday: "Yesterday",
              7: "Last 7 Days",
              14: "Last 14 Days",
              28: "Last 28 Days",
              60: "Last 60 Days",
              90: "Last 90 Days",
              custom: "Custom Range",
            }[filterType]} ▾
          </button>


          {showDropdown && (
            <div className="dropdown-menu">

              {[
                { key: "today", label: "Today" },
                { key: "yesterday", label: "Yesterday" },
                { key: "7", label: "Last 7 Days" },
                { key: "14", label: "Last 14 Days" },
                { key: "28", label: "Last 28 Days" },
                { key: "60", label: "Last 60 Days" },
                { key: "90", label: "Last 90 Days" },
                { key: "custom", label: "Custom Range" },
              ].map((item) => (
                <p
                  key={item.key}
                  className={`dropdown-item ${filterType === item.key ? "active-filter" : ""}`}
                  onClick={() => handleQuickFilter(item.key)}
                >
                  {item.label}
                </p>
              ))}

            </div>

          )}
        </div>
      </div>

      {filterType === "custom" && (
        <div className="custom-date-box">
          <div>
            <label>From</label>
            <input
              type="date"
              value={customFrom}
              onChange={(e) => setCustomFrom(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              value={customTo}
              onChange={(e) => setCustomTo(e.target.value)}
            />
          </div>
        </div>
      )}

      <div className="leads-newvendor">
        {currentItems.length === 0 ? (
          <div className="empty-leads">
            <h2>No Leads Found</h2>
            <p>No data found for selected filters.</p>
          </div>
        ) : (
          currentItems.map((ele, idx) => (
            <ArticleCard
              key={idx}
              id={ele.id}
              articleId={ele.user_id}
              user_id={ele.user_id}
              title={ele.name}
              author={ele.store.businessDetails.businessName}
              category={ele.store.category}
              status={ele.status}
              createdAt={ele.createdAt}
              email={ele.email}
              phone={ele.phone}
              connected_time={ele.connected_time}
              onStatusChange={updateStatusInBackend}
              onConnectedAction={saveConnectedTime}
              plan={plan}
              planData={planData}
            />
          ))
        )}
      </div>
      <div className="pagination-container">
        <button
          className="page-btn"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </button>

        <span className="page-info">
          Page {currentPage} of {Math.ceil(filteredLeads.length / itemsPerPage)}
        </span>

        <button
          className="page-btn"
          disabled={currentPage === Math.ceil(filteredLeads.length / itemsPerPage)}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>

    </>
  );
}

export default Leads;
